"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Loading = function () {
    return ((0, preact_1.h)("div", { class: 'loading' },
        (0, preact_1.h)("p", { class: 'loading__text' }, "Loading..."),
        (0, preact_1.h)("div", { class: 'lds-dual-ring' })));
};
exports.default = Loading;
